<mat-accordion>
  <app-taxpayer></app-taxpayer>
  <app-establishment></app-establishment>
</mat-accordion>
